export default __webpack_public_path__ + "static/media/Fidelity-Computer-Crime-Quotation-Proposal-Form.fe395daa.pdf";